import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1243bebd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "coal-container",
  id: "coal-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3 me-top-lg"
}, " 煤炭业务管理困境 ", -1));
const _hoisted_3 = {
  class: "me-top-lg"
};
const _hoisted_4 = {
  class: "me-content-lg"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, " 智能运销管理系统 ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info dis-space-1"
}, " 智能运销管理系统为煤炭行业企业提供一个全面的信息管理平台，构建从合同签订、调拨计划到排队叫号、自动识别进矿、无人值守磅房、 筒仓装煤、自动识别出矿等环节的标准化“大闭环管理”，规范各业务节点流程，杜绝人为作弊行为，实现运销业务的精细化管理， 帮助企业实现降本增效。 ", -1));
const _hoisted_8 = {
  class: "sys-imgPanel"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "title me-sub-title"
};
const _hoisted_11 = {
  class: "flow"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "coal-flow-img"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "软件界面", -1));
const _hoisted_18 = {
  class: "soft-view-imgPanel me-top-lt"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "硬件设备", -1));
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"row1\" data-v-1243bebd><div class=\"img1\" data-v-1243bebd><label class=\"text-label me-main-title\" data-v-1243bebd>道闸</label></div><div class=\"img2\" data-v-1243bebd><label class=\"text-label\" data-v-1243bebd><label class=\"text-label me-main-title\" data-v-1243bebd>一体机</label></label></div></div><div class=\"row2\" data-v-1243bebd><div class=\"img3\" data-v-1243bebd><label class=\"text-label me-main-title\" data-v-1243bebd><label class=\"text-label\" data-v-1243bebd>LED屏</label></label></div><div class=\"img4\" data-v-1243bebd><label class=\"text-label me-main-title\" data-v-1243bebd> 摄像头 </label></div></div>", 2);
const _hoisted_23 = [_hoisted_21];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "核心优势", -1));
const _hoisted_25 = {
  class: "advance-card me-top"
};
const _hoisted_26 = {
  class: "left"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "right"
};
const _hoisted_29 = {
  class: "me-content-lg"
};
const _hoisted_30 = {
  class: "me-content-lt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["idff-content", {
      'idff-content-entry': _ctx.idffContentState.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    }),
    id: "idff-content"
  }, [_hoisted_2, _createElementVNode("section", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coalCardList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "idd-card",
      key: index
    }, [_createElementVNode("label", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.content), 1), _createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_5)]);
  }), 128))])], 6), _createElementVNode("div", {
    class: _normalizeClass(["sys-info me-top-lg transport-sale-system", {
      'transport-sale-system-entry': _ctx.transportSaleSystemState.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    }),
    id: "transport-sale-system"
  }, [_hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: _ctx.sysImg
  }, null, 8, _hoisted_9)])], 6), _createElementVNode("div", {
    class: "coal-img me-top-lg",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("label", {
    class: _normalizeClass({
      coalFlowlabelActive: _ctx.coalFlowlabelActive === 1
    }),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.coalFlowMouseClickHandle(1))
  }, "煤矿场景业务详解图", 2), _createElementVNode("label", {
    class: _normalizeClass({
      coalFlowlabelActive: _ctx.coalFlowlabelActive === 2
    }),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.coalFlowMouseClickHandle(2))
  }, "煤厂场景业务详解图", 2)]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("img", {
    class: _normalizeClass({
      coalFlowImgActive: _ctx.coalFlowlabelActive === 1
    }),
    src: _ctx.coalFlowImg1
  }, null, 10, _hoisted_12), [[_vShow, _ctx.coalFlowlabelActive === 1]]), _withDirectives(_createElementVNode("img", {
    class: _normalizeClass({
      coalFlowImgActive: _ctx.coalFlowlabelActive === 2
    }),
    src: _ctx.coalFlowImg2
  }, null, 10, _hoisted_13), [[_vShow, _ctx.coalFlowlabelActive === 2]])])], 4), _createElementVNode("div", {
    class: "coal-flow",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("img", {
    src: _ctx.businessImg1
  }, null, 8, _hoisted_15), [[_vShow, _ctx.coalFlowlabelActive === 1]]), _withDirectives(_createElementVNode("img", {
    src: _ctx.businessImg2
  }, null, 8, _hoisted_16), [[_vShow, _ctx.coalFlowlabelActive === 2]])])], 4), _createElementVNode("div", {
    class: _normalizeClass(["soft-view", {
      'soft-view-entry': _ctx.softViewState.showTime
    }]),
    id: "soft-view"
  }, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: _ctx.softViewImg
  }, null, 8, _hoisted_19)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["device-content me-top-lg", {
      'device-content-entry': _ctx.deviceContentState.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    }),
    id: "device-content"
  }, [_hoisted_20, _createElementVNode("div", {
    class: "device-imgPanel me-top",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, _hoisted_23, 4)], 6), _createElementVNode("div", {
    class: _normalizeClass(["center-content", {
      'center-content-entry': _ctx.centerContentState.showTime
    }]),
    id: "center-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centerAdvanceList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "advance-item",
      key: index
    }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_27)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("label", _hoisted_29, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(item.content), 1)])]);
  }), 128))])], 6)]);
}